module.exports = __webpack_public_path__ + "static/media/tools-audio2.79641100.svg";